import React from "react";

export default function Hero() {
  const handleScroll = () => {
    const projectsSection = document.getElementById("projects");

    if (projectsSection) {
      projectsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div id="hero">
      <h1>Harpreet Singh</h1>

      <h2>Project Manager &amp; Software Developer</h2>

      <p className="hero-description">
        Harpreet Singh is a Project Manager and Software Developer with 14+
        years of professional experience in software development, project
        management, technology leadership, team coordination, and software
        delivery.
      </p>

      <button
        className="btn"
        onClick={handleScroll}
        aria-label="View Harpreet Singh's professional capabilities"
      >
        View My Work
      </button>

      <div className="scroll-down" aria-hidden="true">
        ↓ Scroll Down
      </div>
    </div>
  );
}
